/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { FlexBox, FlexBoxAlignItems, SegmentedButton, SegmentedButtonItem } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base/dist';
import { TimeFormat as TimeFormatENUM, UserSettings } from '../../types';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../store/Products';
import { useTranslations } from '../../hooks/useTranslations';

const TimeFormat: React.FC = () => {
    const userSettings: UserSettings = useSelector((state: any) => state.productList.userSettings);
    const dispatch = useDispatch<any>();
    const { t } = useTranslations();

    const onFormatChange = (event: CustomEvent) => {
        const selectedKey: TimeFormatENUM = event.detail.selectedItems[0].attributes['data-key'].value;

        dispatch(
            actions.setUserSettings({
                ...userSettings,
                selectedTimeFormat: userSettings.timeFormat,
                timeFormat: selectedKey,
            })
        );
    };

    return (
        <FlexBox alignItems={FlexBoxAlignItems.Center} style={{ gap: ThemingParameters.sapContent_Margin_Medium }}>
            <SegmentedButton
                onSelectionChange={onFormatChange}
                style={{
                    minHeight: ThemingParameters.sapElement_Compact_Height,
                    borderRadius: ThemingParameters.sapButton_BorderCornerRadius,
                    border: ThemingParameters.sapButton_BorderWidth,
                    borderColor: ThemingParameters.sapButton_BorderColor,
                }}
            >
                <SegmentedButtonItem selected={userSettings.timeFormat === TimeFormatENUM.TWELVE_HOUR} data-key={TimeFormatENUM.TWELVE_HOUR}>
                    {t(TimeFormatENUM.TWELVE_HOUR)}
                </SegmentedButtonItem>
                <SegmentedButtonItem
                    selected={userSettings.timeFormat === TimeFormatENUM.TWENTY_FOUR_HOUR}
                    data-key={TimeFormatENUM.TWENTY_FOUR_HOUR}
                >
                    {t(TimeFormatENUM.TWENTY_FOUR_HOUR)}
                </SegmentedButtonItem>
            </SegmentedButton>
        </FlexBox>
    );
};

export default TimeFormat;
